'use client';

import { useEffect, useState } from 'react';

import { loadOperatingContext, type OperatingContext } from '@/lib/operating-context';

export type OperatingContextHookState =
  | { kind: 'loading' }
  | OperatingContext
  | { kind: 'error'; message: string };

export function useOperatingContext(): OperatingContextHookState {
  const [state, setState] = useState<OperatingContextHookState>({ kind: 'loading' });

  useEffect(() => {
    let cancelled = false;

    void loadOperatingContext()
      .then((next) => {
        if (cancelled) return;
        setState(next);
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        const message = err instanceof Error ? err.message : 'Failed to load operating context.';
        setState({ kind: 'error', message });
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
